import styled from "styled-components";

export const StyledProductCard = styled.div`
  background: var(--tws-white);
  border-radius: var(--tws-radius-lg);
  overflow: hidden;
  box-shadow: var(--tws-shadow-sm);
  transition: transform 0.2s ease, box-shadow 0.2s ease;
  cursor: pointer;

  &:hover {
    transform: translateY(-2px);
    box-shadow: var(--tws-shadow-md);
  }
`;

export const StyledProductImage = styled.div`
  aspect-ratio: 1 / 1;
  overflow: hidden;
  background: var(--tws-cream);

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    transition: transform 0.3s ease;

    ${StyledProductCard}:hover & {
      transform: scale(1.04);
    }
  }
`;

export const StyledProductBody = styled.div`
  text-align: center;
`;

export const StyledProductTitle = styled.h3`
  font-family: var(--tws-font-heading);
  font-size: 0.85rem;
  font-weight: 600;
  color: var(--tws-dark);
  margin: 0;
  line-height: 1.3;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
`;

export const StyledProductPrice = styled.span`
  font-family: var(--tws-font-heading);
  font-size: 0.85rem;
  font-weight: 500;
  color: var(--tws-brown);
`;

export const StyledImagePlaceholder = styled.div`
  background: var(--tws-muted);
`;
